import { ISite } from "../../../apiFacades/csu/site";
import { Err, ReduxAction } from "../../../typings";

export const CURRENT_SITE_FETCH_REQUESTED = "CURRENT_SITE_FETCH_REQUESTED";
export const putCurrentSitePending = (): ReduxAction<null> => ({
  type: CURRENT_SITE_FETCH_REQUESTED,
  payload: null,
});

export const CURRENT_SITE_FETCH_FULFILLED = "CURRENT_SITE_FETCH_FULFILLED";
export const putCurrentSiteData = (
  site: ISite | null,
): ReduxAction<ISite | null> => ({
  type: CURRENT_SITE_FETCH_FULFILLED,
  payload: site,
});

export const CURRENT_SITE_FETCH_REJECTED = "CURRENT_SITE_FETCH_REJECTED";
export const putCurrentSiteError = (
  message: string,
  code?: string,
): ReduxAction<Err> => ({
  type: CURRENT_SITE_FETCH_REJECTED,
  payload: {
    message,
    code,
  },
});

export type CurrentSiteState = {
  pending: boolean;
  data?: ISite;
  error?: Err;
};

const defaultCurrentSiteReducerState: CurrentSiteState = {
  pending: false,
  data: undefined,
  error: undefined,
};

export const getCurrentProj4 = (siteState: CurrentSiteState) => {
  const srs = siteState?.data?.srs;
  return srs?.isAssumed
    ? srs?.assumedSrs?.intermediateSrsProj4
    : srs?.globalSrs?.proj4;
};

export default function currentSiteReducer(
  state: CurrentSiteState = defaultCurrentSiteReducerState,
  action: ReduxAction<any>,
): CurrentSiteState {
  switch (action.type) {
    case CURRENT_SITE_FETCH_REQUESTED:
      return {
        ...defaultCurrentSiteReducerState,
        pending: true,
      };
    case CURRENT_SITE_FETCH_FULFILLED:
      return {
        ...defaultCurrentSiteReducerState,
        data: action.payload,
      };
    case CURRENT_SITE_FETCH_REJECTED:
      return {
        ...defaultCurrentSiteReducerState,
        error: action.payload,
      };
    default:
      return state;
  }
}
